import React, { Component , Fragment } from "react";
import ScrollToTop from 'react-scroll-up';
import Slider from "react-slick";
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Cookies } from "react-cookie";

import { slideSlick } from "../../page-demo/script";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import CallAction from "../../elements/callaction/CallAction";
import Helmet from "../../component/common/Helmet";
import NewsList from "../../component/newsList";
import { FiLayers, FiDollarSign ,FiChevronUp , FiTv } from "react-icons/fi";
import Counter from "../../elements/counters/Counter";

import { getAllNews, getAllPartners } from '../../redux/actions';

const SlideList = [
    {
        textPosition: 'text-right',
        bgImage: 'bg_image--31',
        category: '',
        title: 'Expert Alumni',
        description: 'Together we are family. Get discount on our services and amazing offers from our partners',
        buttonText: 'JOIN NOW',
        buttonLink: '/join-now'
    },
    {
        textPosition: 'text-left',
        bgImage: 'bg_image--32',
        category: '',
        title: 'EEVS',
        description: 'Expert Education & Visa Services - Choose the right course & pursue your dream career.',
        buttonText: 'Visit Website',
        buttonLink: 'https://www.experteducation.com.au/'
    },
    
]

const ServiceListOne = [
    {
        icon: <FiTv />,
        title: 'News & Announcements',
        description: 'Get notified as soon as there is industry relevant news or new announcement is made.'
    },
    {
        icon: <FiLayers />,
        title: 'Points on every service',
        description: 'Collect points on every service you use and redeem them in your future appoinments. '
    },
    {
        icon: <FiDollarSign />,
        title: 'Discount from partners',
        description: 'We collaborate with many local partners. Get discount on their services. '
    },
]


class Landing extends Component{

    configureReferral = () => {
        const parsed = queryString.parse(this.props.location.search);
        if(parsed && parsed.code) {
            let cookies = new Cookies();
            cookies.set('referralCode', parsed.code, { path: '/' });
        }
    }
    componentDidMount = () => {
        const { getAllNews, getAllPartners } = this.props;
        getAllNews({offset: 0, limit: 3});
        getAllPartners({offset: 0, limit: 3});
        this.configureReferral();
    }


    render(){
        const { news, partners } = this.props;
        return(
            <Fragment> 
                <Helmet pageTitle="EEVS Alumni" />

                {/* Start Header Area  */}
                <Header headerPosition="header--static logoresize" logo="all-dark" color="color-black"/>
                {/* End Header Area  */}

                {/* Start Slider Area   */}
                <div className="slider-wrapper">
                    <div className="slider-activation">
                        <Slider className="rn-slick-dot dot-light" {...slideSlick}>
                            {SlideList.map((value , index) => (
                                <div className={`slide slide-style-2  without-overlay d-flex align-items-center justify-content-center bg_image ${value.bgImage}`} key={index}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className={`inner ${value.textPosition}`}>
                                                    {value.category ? <span>{value.category}</span> : ''}
                                                    {value.title ? <h1 className="title theme-gradient">{value.title}</h1> : ''}
                                                    {value.description ? <p className="description">{value.description}</p> : ''}
                                                    {value.buttonText ? <div className="slide-btn"><a className="rn-button-style--2 btn-solid" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
                {/* End Slider Area   */}

                 {/* Start Service Area  */}
                <div className="service-area creative-service-wrapper ptb--120 bg_color--1" id="service">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="feature-area">
                                    <span>EEVS Alumni</span>
                                    <h3 className="title mt--20 fontWeight500 lineheight--1-8">By choosing to become a member of our alumni that recently facilitates service to more than
                                                40,000+ alumni members in more than 11 countries, you will be able to receive offers and
                                                services that you would most likely to enjoy benefits from. From attaining discounts from our
                                                partners to getting points for using our service, you will be able to enjoy your membership to the
                                                max.</h3>
                                </div>
                            </div>
                        </div>
                        <div className="row service-one-wrapper mt--30">
                            {ServiceListOne.map( (val , i) => (
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                                    <div className="service service__style--2 text-center">
                                        <div className="icon">
                                            {val.icon}
                                        </div>
                                        <div className="content">
                                            <h3 className="title">{val.title}</h3>
                                            <p>{val.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>  
                {/* End Service Area  */} 


                {/* Start Featured Service Area  */}
                <div className="rn-featured-service-area pt--90 pb--120 bg_color--5">
                    <div className="container">
                        <div className="row">

                            {/* Start Single Service  */}
                            <div className="col-lg-3 col-md-6 col-12 mt--30">
                                <div className="section-title">
                                    <h2 className="title">Partners</h2>
                                    <p>We enjoy collaborating and working with authentic partners, and we look forward to helping you
                                            with our services. By joining the membership you will have access to the services, offers,
                                            discounts offered by our partners.</p>
                                    <div className="service-btn">
                                        <a className="btn-transparent rn-btn-dark" href="/partners"><span className="text">See all</span></a>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Service  */}

                            {/* Start Single Service  */}
                            <div className="col-lg-9">
                                <div className="row">
                                    {partners.map((partner , index) => (
                                        <div className="col-lg-4 col-md-4 mt--30" key={partner.id}>
                                            <div className="standard-service">
                                                <div className="thumbnai">
                                                    <img src={`https://eevs-almuni.s3-ap-southeast-2.amazonaws.com/${partner.thumbnail}`} alt={partner.name}/>
                                                </div>
                                                <div className="content">
                                                    <h3><a href={`/partners/${partner.id}`}>{partner.name}</a></h3>
                                                    <p>{partner.intro}</p>
                                                    <a className="btn-transparent rn-btn-dark" href={`/partners/${partner.id}`}><span className="text">More</span></a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                
                            </div>
                            {/* End Single Service  */}

                        </div>
                    </div>                
                </div>
                {/* End Featured Service Area  */}

                {/* Start Counterup Area */}
                <div className="counterup-area pb--80 pt--40 theme-text-white" style={{backgroundColor: '#0054a6'}}>
                    <div className="container">
                        <Counter />
                    </div>
                </div>
                {/* End Counterup Area */}


                {/* Start Blog Area */}
                <div className="rn-blog-area pt--120 pb--80 bg_color--1">
                    <div className="container">
                        <div className="row align-items-end">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center">
                                    <h2 className="title">Latest News</h2>
                                    <p>Current news regarding student and migration services.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--60">
                            <NewsList news={news} />
                        </div>    
                    </div>    
                </div>
                {/* End Blog Area */}

                {/* Start call To Action  */}
                <CallAction />
                {/* End call To Action  */}

                {/* Start Footer Style  */}
                <Footer />
                {/* End Footer Style  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
            </Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    const { news } = state.News;
    const { partners } = state.Partner;
    return { news, partners };
};

export default connect(mapStateToProps, { getAllNews, getAllPartners })(Landing);